export class ChannelProgramApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getChannelPrograms({ channelId }) {
    return this.#http.get(`/api/channel-programs/channel/${channelId}`);
  }

  async editChannelPrograms({ channelId, ...body }) {
    return this.#http.put(`/api/channel-programs/channel/${channelId}`, body);
  }

  async deleteChannelPrograms({ channelId }) {
    return this.#http.delete(`/api/channel-programs/channel/${channelId}`);
  }
}
